import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  Database,
  Eye,
  Cookie,
  Share2,
  UserCheck,
  Mail,
  ShieldCheck,
  Clock,
} from "lucide-react";
import { PublicNavbar, PublicFooter } from "./PublicLayout";
import "./LandingPage.css";
import "./StaticPages.css";

function PrivacyPolicy() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    {
      id: "collect",
      icon: Database,
      color: "#8b5cf6",
      bg: "rgba(139, 92, 246, 0.1)",
      title: t("privacy.collectTitle"),
      content: (
        <>
          <p>{t("privacy.collectIntro")}</p>
          <ul>
            <li><strong>{t("privacy.collectAccount")}</strong> — {t("privacy.collectAccountDesc")}</li>
            <li><strong>{t("privacy.collectDesign")}</strong> — {t("privacy.collectDesignDesc")}</li>
            <li><strong>{t("privacy.collectPayment")}</strong> — {t("privacy.collectPaymentDesc")}</li>
            <li><strong>{t("privacy.collectTechnical")}</strong> — {t("privacy.collectTechnicalDesc")}</li>
          </ul>
        </>
      ),
    },
    {
      id: "use",
      icon: Eye,
      color: "#3b82f6",
      bg: "rgba(59, 130, 246, 0.1)",
      title: t("privacy.useTitle"),
      content: (
        <>
          <p>{t("privacy.useIntro")}</p>
          <ul>
            <li>{t("privacy.use1")}</li>
            <li>{t("privacy.use2")}</li>
            <li>{t("privacy.use3")}</li>
            <li>{t("privacy.use4")}</li>
            <li>{t("privacy.use5")}</li>
          </ul>
        </>
      ),
    },
    {
      id: "cookies",
      icon: Cookie,
      color: "#f59e0b",
      bg: "rgba(245, 158, 11, 0.1)",
      title: t("privacy.cookiesTitle"),
      content: (
        <>
          <p>{t("privacy.cookiesIntro")}</p>
          <ul>
            <li><strong>{t("privacy.cookiesEssential")}</strong> — {t("privacy.cookiesEssentialDesc")}</li>
            <li><strong>{t("privacy.cookiesAuth")}</strong> — {t("privacy.cookiesAuthDesc")}</li>
          </ul>
          <p>{t("privacy.cookiesNote")}</p>
        </>
      ),
    },
    {
      id: "thirdparty",
      icon: Share2,
      color: "#10b981",
      bg: "rgba(16, 185, 129, 0.1)",
      title: t("privacy.thirdTitle"),
      content: (
        <>
          <p>{t("privacy.thirdIntro")}</p>
          <ul>
            <li><strong>Stripe</strong> — {t("privacy.thirdStripe")}</li>
            <li><strong>OpenAI</strong> — {t("privacy.thirdOpenai")}</li>
            <li><strong>Google OAuth</strong> — {t("privacy.thirdGoogle")}</li>
          </ul>
          <p>{t("privacy.thirdNoSell")}</p>
        </>
      ),
    },
    {
      id: "rights",
      icon: UserCheck,
      color: "#667eea",
      bg: "rgba(102, 126, 234, 0.1)",
      title: t("privacy.rightsTitle"),
      content: (
        <>
          <p>{t("privacy.rightsIntro")}</p>
          <ul>
            <li>{t("privacy.rights1")}</li>
            <li>{t("privacy.rights2")}</li>
            <li>{t("privacy.rights3")}</li>
            <li>{t("privacy.rights4")}</li>
            <li>{t("privacy.rights5")}</li>
          </ul>
        </>
      ),
    },
    {
      id: "security",
      icon: ShieldCheck,
      color: "#ef4444",
      bg: "rgba(239, 68, 68, 0.1)",
      title: t("privacy.securityTitle"),
      content: <p>{t("privacy.securityDesc")}</p>,
    },
    {
      id: "retention",
      icon: Clock,
      color: "#6366f1",
      bg: "rgba(99, 102, 241, 0.1)",
      title: t("privacy.retentionTitle"),
      content: <p>{t("privacy.retentionDesc")}</p>,
    },
    {
      id: "contact",
      icon: Mail,
      color: "#ec4899",
      bg: "rgba(236, 72, 153, 0.1)",
      title: t("privacy.contactTitle"),
      content: <p>{t("privacy.contactDesc")}</p>,
    },
  ];

  return (
    <div className="landing-page">
      <PublicNavbar />

      <section className="sp-hero">
        <div className="sp-hero-pattern" />
        <div className="sp-hero-content">
          <h1>{t("privacy.heroTitle")}</h1>
          <p>{t("privacy.heroDesc")}</p>
        </div>
      </section>

      <div className="sp-content">
        <nav className="sp-toc">
          <div className="sp-toc-title">{t("privacy.tocTitle")}</div>
          <ul className="sp-toc-list">
            {sections.map((s) => (
              <li key={s.id}>
                <a href={`#${s.id}`}>{s.title}</a>
              </li>
            ))}
          </ul>
        </nav>

        {sections.map((s) => (
          <section key={s.id} id={s.id} className="sp-section">
            <h2>
              <span
                className="sp-section-icon"
                style={{ background: s.bg, color: s.color }}
              >
                <s.icon size={18} />
              </span>
              {s.title}
            </h2>
            {s.content}
          </section>
        ))}

        <p className="sp-last-updated">{t("privacy.lastUpdated")}</p>
      </div>

      <PublicFooter />
    </div>
  );
}

export default PrivacyPolicy;
